// Lazy wrapper around the react-draft-wysiwyg TextEditor.
//
// TextEditor pulls in react-draft-wysiwyg (+ its own copy of lodash and the
// editor CSS) — ~90KB gzipped. It is only needed on the write paths (create /
// edit prompt, conversation reply, inbox compose). EditPromptPage is
// deliberately NOT route-split (see App.js), which previously forced the whole
// editor stack into the main bundle for every visitor. Splitting the editor
// itself here keeps it out of main while leaving EditPromptPage eager.
//
// The read-only render path (TextEditorReadOnly) is intentionally NOT lazy — it
// only uses draft-js, which is already needed to render prompt bodies.
import React, { Suspense } from 'react';
import CircularLoading from '../commoncomponents/CircularLoading';

const TextEditor = React.lazy(() => import('./TextEditor'));

const TextEditorLazy = props => (
  <Suspense fallback={<CircularLoading />}>
    <TextEditor {...props} />
  </Suspense>
);

export default TextEditorLazy;
